/** Client-visible labels (console, status, masked WS errors) — not used in code/env names. */
export const VENDOR_LABEL_STT = 'TopSpeech';
export const VENDOR_LABEL_TTS = 'TopVoice';

const REPLACEMENTS: Array<[RegExp, string]> = [
  [/OpenAI Realtime/gi, VENDOR_LABEL_STT],
  [/OpenAI/gi, VENDOR_LABEL_STT],
  [/OPENAI/g, 'TOPSPEECH'],
  [/Gemini TTS/gi, `${VENDOR_LABEL_TTS} TTS`],
  [/Gemini Live/gi, `${VENDOR_LABEL_TTS} Live`],
  [/Gemini/gi, VENDOR_LABEL_TTS],
  [/GEMINI/g, 'TOPVOICE'],
];

export function maskVendorNamesForClient(text: string): string {
  if (!text) {
    return text;
  }
  let out = text;
  for (const [pattern, replacement] of REPLACEMENTS) {
    out = out.replace(pattern, replacement);
  }
  return out;
}

export function clientLog(...args: unknown[]): void {
  console.log(...args.map((a) => (typeof a === 'string' ? maskVendorNamesForClient(a) : a)));
}

export function clientError(...args: unknown[]): void {
  console.error(...args.map((a) => (typeof a === 'string' ? maskVendorNamesForClient(a) : a)));
}
